export type FL_ENDING_TYPE =
  | 'classic'
  | 'blockThin'
  | 'ERone'
  | 'ERmany'
  | 'ERmandOne'
  | 'ERoneToMany'
  | 'ERzeroToOne'
  | 'ERzeroToMany'
  | 'diamond'
  | 'none';

export const FL_END_MAPPER = {
  classic: 'flowline_icons:str-fl-end-classic',
  blockThin: 'flowline_icons:str-fl-end-thin',
  ERone: 'flowline_icons:str-fl-end-erone',
  ERmany: 'flowline_icons:str-fl-end-ermany',
  ERmandOne: 'flowline_icons:str-fl-end-ermand',
  ERoneToMany: 'flowline_icons:str-fl-end-one-to-many',
  ERzeroToOne: 'flowline_icons:str-fl-end-zero-to-one',
  ERzeroToMany: 'flowline_icons:str-fl-end-zero-to-many',
  diamond: 'flowline_icons:str-fl-end-diamond'
};
export const FL_START_MAPPER = {
  classic: 'flowline_icons:str-fl-start-classic',
  blockThin: 'flowline_icons:str-fl-start-thin',
  ERone: 'flowline_icons:str-fl-start-erone',
  ERmany: 'flowline_icons:str-fl-start-ermany',
  ERmandOne: 'flowline_icons:str-fl-start-ermand',
  ERoneToMany: 'flowline_icons:str-fl-start-one-to-many',
  ERzeroToOne: 'flowline_icons:str-fl-start-zero-to-one',
  ERzeroToMany: 'flowline_icons:str-fl-start-zero-to-many',
  diamond: 'flowline_icons:str-fl-start-diamond'
};
